module.exports = __webpack_public_path__ + "img/iconCaoZuoBangZhu.96695f79.svg";